// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Sidebar } from "semantic-ui-react";
import { useSessionStorage } from "@jvs-group/jvs-mairistem-tools";
import { ApplicationFrameContext } from "./ApplicationFrameContext";
import { ApplicationNotification } from "../ApplicationNotification";

// eslint-disable-next-line max-len
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationFrameNotification = props => {
  const {
    children
  } = props;
  const {
    notification: {
      open
    }
  } = React.useContext(ApplicationFrameContext);
  const [pin, setPin] = useSessionStorage("interaction.notification.pin", false);
  const handlePin = React.useCallback(() => {
    setPin(p => !p);
  }, [setPin]);
  return React.useMemo(() => /*#__PURE__*/_jsxs(Sidebar.Pushable, {
    children: [/*#__PURE__*/_jsx(ApplicationNotification, {
      pin: pin,
      onPin: handlePin
    }), /*#__PURE__*/_jsx(Sidebar.Pusher, {
      dimmed: open && !pin,
      children: children
    })]
  }), [open, pin, children, handlePin]);
};